import AuthService from 'Lib/API/Auth';
import MemberService from 'Lib/API/Member';
import { getLocalStorageRegistration, setLocalStorageDateRange, setLocalStorageRegistration } from '_metronic/_helpers';
import { setLocalizationMoment } from 'helper/dateFormat';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import { setBulkClassDetails } from 'services/api/bulkClass';
import BulkClassInfo from './SchoolComponents/ClassInfo/BulkClassInfo';
import { Spinner } from './Theme';

export const BulkSchool = () => {
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState(false);
    const [coverImage, setCoverImage] = useState(null);
    const dispatch = useDispatch()


    const getBulkClassById = async (Token) => {
        setIsLoading(true)
        const payload = {
            id: params?.id,
        }
        try {
            const res = await MemberService.getClassesByBulkClassId(Token, payload)
            setCoverImage(res?.result?.background || "")
            dispatch(setBulkClassDetails(res?.result));
            setLocalStorageRegistration({
                activeStep: getLocalStorageRegistration()?.activeStep,
                registerFormId: res?.result?.form,
                RegisterData: getLocalStorageRegistration()?.RegisterData,
                RegisterRequiredFelids: getLocalStorageRegistration()?.RegisterRequiredFelids,
                bulkClassDetails: res?.result
            });
            const startDateDiff = moment().diff(moment(res?.result?.bulkStartDate), 'days');
            const endDateDiff = moment().diff(res?.result?.bulkEndDate ? moment(res?.result?.bulkEndDate) : moment(), 'days');
            if (res?.result?.archived) {
                enqueueSnackbar('This bulk registration is no longer available due to its archived status', {
                    variant: 'error',
                });
            }
            if (endDateDiff > 0) {
                enqueueSnackbar('This bulk registration is no longer available due to its expiration date', {
                    variant: 'error',
                });
            }
            else if (startDateDiff < 0) {
                enqueueSnackbar(`This bulk registration has not yet begun. Please check back closer to the start date for access`, {
                    variant: 'error',
                });
            }
        } catch (error) {
            enqueueSnackbar(error?.data?.message, {
                variant: 'error',
            });
            dispatch(setBulkClassDetails({}));

        } finally {
            setIsLoading(false)
        }
    };
    const generateToken = async () => {
        setIsLoading(true)
        const subDomain = window.location.hostname.split('.')[0];
        const hostName = subDomain === 'localhost' ? (process.env.REACT_APP_LOCAL_ORGKEY || 'stagerms') : subDomain
        try {
            const res = await AuthService.generateToken(hostName);
            localStorage.setItem('paymentMethodSchool', JSON.stringify(res?.paymentMethodCreditCard));
            localStorage.setItem("achPaymentMethodSchool",
                JSON.stringify(res?.paymentMethodAch)
            );
            localStorage.setItem('schoolToken', res?.token);
            localStorage.setItem('schoolOrgId', res?._id);
            localStorage.setItem('logoImgSchool', res?.logoImg);
            localStorage.setItem('orgName', res?.orgName);
            localStorage.setItem('country', JSON.stringify(res?.country || {}));
            localStorage.setItem('memberPortal', res?.memberPortal || false);
            localStorage.setItem('allowInstallments', res?.allowInstallments || false);


            setLocalizationMoment(res?.country?.local || "en");
            document.title = `${res?.orgName}`;

            getBulkClassById(res?.token);
        } catch (error) {
            enqueueSnackbar(error?.data?.message, {
                variant: 'error',
            });
        } finally {
            setIsLoading(false)
        }
    };
    useEffect(() => {
        generateToken()
    }, [])
    return (
        <>
            {isLoading ? (
                <Spinner>
                    <PulseLoader color={"#2555EF"} size={"30px"} />
                </Spinner>
            ) : (
                <BulkClassInfo />
            )}
        </>
    );
};
